import { render, staticRenderFns } from "./ModuleHero.vue?vue&type=template&id=f503b4de&scoped=true"
import script from "./ModuleHero.vue?vue&type=script&lang=js"
export * from "./ModuleHero.vue?vue&type=script&lang=js"
import style0 from "./ModuleHero.vue?vue&type=style&index=0&id=f503b4de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f503b4de",
  null
  
)

export default component.exports